import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Rx';
import { map } from 'rxjs/operators';
import { AppConfig } from './app-config';
import { BaseService } from './base/base.service';
import { WebSocketService } from './websocket.service';

@Injectable({
  providedIn: 'root'
})
export class PlanningSocketService extends BaseService<any> {

  public messages: Subject<any>;
  private connectionId: string;

  constructor(
    protected config: AppConfig,
    protected http: HttpClient,
    private _wsService: WebSocketService
  ) {
    super(http, config);
  }

  async createConnection() {
    this.messages = <Subject<any>> this._wsService.connect(this.getResourceUrl())
      .pipe(map((response: MessageEvent) => {
        let data = JSON.parse(response.data);
        return {
          data
        };
      }));
  }

  setConnectionId(connectionId) {
    this.connectionId = connectionId;
  }

  getConnectionId() {
    return this.connectionId;
  }

  protected getResourceUrl(): string {
    return this.config.getPlanningWSUrl();
  }
}